const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fileUrl = (itemId, slot, token, download = false) =>
  `${API}/formation/items/${itemId}/file/${slot}?auth=${encodeURIComponent(token)}${download ? '&download=true' : ''}`;

export const slideUrl = (item, n, token, thumb = false) =>
  `${API}/formation/items/${item.id}/slides/${n}?auth=${encodeURIComponent(token)}${thumb ? '&thumb=true' : ''}&v=${item.slides_version || ''}`;

// Upload par morceaux de 5 Mo (contourne la limite de taille du proxy)
export async function chunkedUpload(api, file, onProgress) {
  const { data } = await api().post('/formation/uploads/init', {
    filename: file.name, content_type: file.type || 'application/octet-stream', size: file.size,
  });
  const size = data.chunk_size;
  const total = Math.max(1, Math.ceil(file.size / size));
  for (let i = 0; i < total; i += 1) {
    const blob = file.slice(i * size, (i + 1) * size);
    for (let attempt = 1; ; attempt += 1) {
      try {
        await api().put(`/formation/uploads/${data.upload_id}/chunk?index=${i}`, blob, {
          headers: { 'Content-Type': 'application/octet-stream' },
        });
        break;
      } catch (e) {
        if (attempt >= 3 || (e?.response?.status && e.response.status < 500)) throw e;
        await new Promise((r) => setTimeout(r, 1500 * attempt));
      }
    }
    onProgress && onProgress(Math.round(((i + 1) / total) * 100));
  }
  return data.upload_id;
}

export const TYPE_META = {
  book: { label: 'Book / diaporama', accept: 'application/pdf,.pdf' },
  audio: { label: 'Audio', accept: 'audio/*,.mp3,.m4a,.wav,.aac,.ogg' },
  video: { label: 'Vidéo', accept: 'video/*,.mp4,.mov,.webm' },
  document: { label: 'Document', accept: '*/*' },
};

export const fmtSize = (b) => (!b ? '' : b > 1048576 ? `${(b / 1048576).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Mo` : `${Math.round(b / 1024)} Ko`);
